import { useEffect } from "react";
import { Outlet } from "react-router";
import { ClearPage } from "@/util/analyticsHelper.js";

export function AnalyticsTracking() {
  useEffect(() => {
    return () => {
      ClearPage();
    };
  });

  return <Outlet />;
}
